export default {"src":"/_next/static/media/workfocus-logo-small.afc8d734.svg","height":44,"width":44,"blurWidth":0,"blurHeight":0};